<script>
import TierInputs from './tier-inputs'
import SortableList from './sortable-list'
import SortableItem from './sortable-item'
import { mapActions } from 'vuex'

export default {
  name: 'GroupsInputs',
  components: {
    TierInputs,
    SortableItem,
    SortableList,
  },
  props: {
    value: {
      type: Array,
      default: () => [],
    },
    viewMode: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      groups: [],
    }
  },
  watch: {
    value: {
      handler(val) {
        this.groups = [...val]
      },
      deep: true,
    },
  },
  mounted() {
    this.groups = [...this.value]
  },
  methods: {
    ...mapActions('category', ['removeItem', 'sortItem']),
    sortEnd({ oldIndex, newIndex }) {
      this.sortItem({ oldIndex, newIndex })
    },
  },
}
</script>

<template>
  <sortable-list
    v-model="groups"
    :class="$style.root"
    :disabled="viewMode"
    @sort-end="sortEnd"
  >
    <sortable-item
      v-for="(group, index) in groups"
      :key="index"
      :disabled="viewMode"
      :index="index"
    >
      <div
        :class="$style.group"
      >
        <div :class="$style.groupInput">
          <el-form-item
            :prop="`tree[${index}].name`"
            :class="$style.input"
          >
            <el-input
              v-model="group.name"
              :class="{[$style.disabledInput]: viewMode}"
              :disabled="viewMode"
            />
            <template v-if="groups.length > 1 && !viewMode">
              <i :class="['el-icon-d-caret', $style.icon, $style.iconDrag]" />
              <i
                :class="['el-icon-delete', $style.icon, $style.iconDel]"
                @mousedown.stop=""
                @click="removeItem({index})"
              />
            </template>
          </el-form-item>
        </div>
        <div :class="$style.groupChildren">
          <tier-inputs
            v-model="group.items"
            :view-mode="viewMode"
            :group-index="index"
          />
        </div>
      </div>
      <hr
        v-if="index < (value.length - 1)"
        :class="['divider-primary', $style.divider]"
      >
    </sortable-item>
  </sortable-list>
</template>

<style lang="scss" module>
.root {
  // display: grid;
}

.divider {
  margin: 2rem 0;
}

.group {
  display: flex;
  // align-items: flex-start;
}

.groupInput {
  flex-basis: rem(240px);
  margin-top: rem(26px);
  margin-right: rem(40px);
}

.input {
  position: relative;
  margin-bottom: rem(8px);
}

.disabledInput {
  :global {
    .el-input__inner {
      color: var(--color-text) !important;
    }
  }
}

.icon {
  position: absolute;
  top: 50%;
  right: 0;
  color: var(--color-primary);
  cursor: pointer;
  transform: translateY(-50%);
}

.iconDel {
  right: rem(6px);
}

.iconDrag {
  right: rem(24px);
}
</style>
